module.exports = __webpack_public_path__ + "static/media/hourglass_gold_fulla7fe57bb8c3d6de643b36a5a7c3e2687.webp";